import { LocaleModule } from "@/core/modules/locale/objects/LocaleModule";

import { en } from "./en";
import { it } from "./it";

export const bankLocaleModule: LocaleModule = {
  name: "bank",
  messages: { en: en, it: it },
};
